import { stringify } from 'query-string'

export const UBERSUGGEST_VERSION = 8
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'
export const API_KW_RELEVANCY_URL =
  process.env.REACT_APP_KW_RELEVANCY_API_URL || ''
export const ROOT_URL = process.env.REACT_APP_ROOT_URL || ''
export const AIWRITER_BASE_URL = process.env.REACT_APP_AIWRITER_BASE_URL || ''

// Limit of characters for Keyword
export const MAX_KEYWORD_CHARACTER_LENGTH = 80
// Limited time vars
export const REPORT_POLL_DELAY = 5000
export const AUDIT_POLL_DELAY = 5000
export const AUDIT_POLL_DELAY_INTERVAL = 3000
export const CONTENT_INTEGRATION_ROUTE = '/labs/ai_writer'
export const TIMESTAMP_LIFETIME = 5 * 60 // timestamp expires in 5 minutes
export const DEFAULT_AIW_WORDS_LIMITS = 10000
export const PAGE_SPEED_INSIGHT_URL =
  'https://pagespeedonline.googleapis.com/pagespeedonline/v5/runPagespeed'
export const GENERIC_RECURLY_ERRORS = [
  'internal_server_error',
  'invalid_api_key',
  'invalid_api_version',
  'invalid_content_type',
  'invalid_permissions',
  'invalid_token',
]
export const CHECKOUT_ERRORS = {
  BLOCKED_PAYMENT_METHOD: 'blacklisted_payment_method',
  THREE_D_SECURE_ACTION_REQUIRED: 'three_d_secure_action_required',
}
export const EN_INTERFACE_PAYMENT_ERROR_MESSAGE =
  'This credit card has been used for a free trial recently. Please use a different payment method'
export const CREDIT_ARTICLE_LINK =
  'https://ubersuggest.zendesk.com/hc/en-us/articles/14699185923099'

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || ''
export const DISABLE_RECAPTCHA =
  process.env.REACT_APP_DISABLE_RECAPTCHA || 'false'
export const DISABLE_TURNSTILE =
  process.env.REACT_APP_DISABLE_TURNSTILE || 'false'

export const SITE_AUDIT_PROJECT_DOMAIN = 'project'
export const SITE_AUDIT_CUSTOM_DOMAIN = 'customDomain'

export const forceRecaptchaPaths = [
  '/signup',
  '/login',
  '/register',
  '/forgot-password',
  '/change-password',
  '/verify-email',
  '/account_billing',
]

export const skipFetchAfterLoginDataPaths = ['checkout', 'pricing']

export const skipSideBarPaths = [
  '/signup',
  '/checkout',
  '/pricing',
  '/login',
  '/register',
  '/forgot-password',
  '/change-password',
  '/verify-email',
]
export const skipNavBarPaths = [
  '/signup',
  '/checkout',
  '/login',
  '/register',
  '/forgot-password',
  '/change-password',
]
export const skipLimitPromptPaths = [
  '/pricing',
  '/checkout',
  '/dashboard',
  '/position_tracking',
  '/settings/account_billing',
  '/login',
  '/register',
  '/forgot-password',
  '/change-password',
  '/verify-email',
]
export const skipPromptPaths = [
  '/pricing',
  '/checkout',
  '/settings/account_billing',
  '/login',
  '/register',
  '/forgot-password',
  '/change-password',
  '/verify-email',
]

export const skipCreditLimitPromptPaths = [
  '/pricing',
  '/checkout',
  '/settings/account_billing',
  '/login',
  '/register',
  '/forgot-password',
  '/change-password',
  '/verify-email',
]
export const skipExitIntentModalPaths = [
  '/pricing',
  '/checkout',
  '/dashboard',
  '/position_tracking',
  '/settings/account_billing',
  '/settings/notifications',
  '/login',
  '/register',
  '/forgot-password',
  '/change-password',
  '/verify-email',
]

export const skipPastDueNoticePaths = [
  '/settings/account_billing',
  '/settings/notifications',
]

export const skipEmailConfirmAlertPaths = [
  '/signup',
  '/checkout',
  '/login',
  '/register',
  '/forgot-password',
  '/change-password',
  '/verify-email',
]

export const enableProjectCreationOnUnloggedPaths = [
  '/overview',
  '/keyword_ideas',
  '/traffic_analyzer/keywords',
]

export const getGoogleSignInURL = (options = {}) => {
  return `${API_BASE_URL}/google_auth?${stringify(options)}`
}

export const getGoogleSignOutURL = (options = {}) => {
  return `${API_BASE_URL}/logout?${stringify(options)}`
}

export const getCheckoutURL = (options = {}) => {
  return `/${options.lang ? options.lang : 'en'}/checkout?${stringify(options)}`
}

export const getPricingURL = (options = {}) => {
  return `/${options.lang ? options.lang : 'en'}/pricing?${stringify(options)}`
}

export const CUSTOM_PLAN_INQUIRY_FLAG =
  process.env.REACT_APP_CUSTOM_PLAN_INQUIRY_FLAG === 'true' || false

export const REFRESH_SERP_CREDIT_COUNT = 2

export const AFFILIATION_ID_LIFE_TIME_IN_DAYS = 30

export const KEYWORD_SHOW_LIMIT = 5

export const SUPPORTED_LANGS = [
  'pt',
  'es',
  'de',
  'it',
  'fr',
  'nl',
  'ja',
  'zh',
  'en',
]

export const USER_STAY_REPORT_DELAY = 2000

export const NOT_TRIAL_PLANS = ['lifetime']

export const REPORTS = {
  PDF: 'PDF',
  IMG: 'IMG',
  CSV: 'CSV',
}

export const PROMO_LABEL_VALUE = 'yearly_bundle'
export const KEYWORD_METRICS = {
  SD: 'search_difficulty',
  SI: 'search_intent',
}

export const OK_STATUS = 'ok'
export const PENDING_STATUS = 'pending'
export const FAILED = 'failed'

export const SHOW_ATP_LIFETIME_MODAL_PLANS = ['monthly', 'yearly', 'lifetime']

export const KEYWORD_LIMIT_PLANS = {
  TIER1: 125,
}

export const KEYWORD_TEMPLATE_URL = `${process.env.REACT_APP_FILE_URL}/adding-keywords-template.csv`

export const ISSUES_BREAKDOWN_URL_MISMATCH_ERROR = 'Some urls in append are invalid.'
